import React, {FC} from "react"
import styled from "styled-components"
import {isString} from "lodash"

import {Body, H1, H4} from "@irati/ui/src/Typography"
import FormattedMessage, {InjectIntl, injectIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {Card} from "@irati/ui/src/Layout"
import Button from "@irati/ui/src/Button/Button"
import {ButtonLink, ButtonRouterLink} from "@irati/ui/src/Link"

import Recommended from "./Recommended"

const StyledCard = styled(Card)`
  position: relative;
  width: 100%;
`

interface Props extends InjectIntl {
  emoji: string
  title: string
  text: string
  buttonText: string
  onClick?: () => void
  isRecommended?: boolean
  link?: string
  href?: string
  app?: string
}

const ModalWidget: FC<Props> = ({isRecommended, href, link, app = "admin", emoji, title, text, buttonText, onClick, formatMessage}) => {
  return (
    <StyledCard>
      <Flex direction="column" height="100%" justifyContent="space-between">
        <div>
          <Flex justifyContent="center" marginBottom={1}>
            <H1>{emoji}</H1>
          </Flex>
          <H4 marginBottom={1} textAlign="center">
            <FormattedMessage id={title} />
          </H4>
          <Body small marginBottom={2} textAlign="center">
            {isString(text) ? <FormattedMessage id={text} /> : text}
          </Body>
        </div>
        <Flex justifyContent="center">
          {link && (
            <ButtonRouterLink small primary onClick={onClick} to={link} app={app}>
              <FormattedMessage id={buttonText} />
            </ButtonRouterLink>
          )}
          {href && (
            <ButtonLink small primary onClick={onClick} href={formatMessage({id: href})} target="_blank">
              <FormattedMessage id={buttonText} />
            </ButtonLink>
          )}
          {!link && !href && (
            <Button small primary onClick={onClick}>
              <FormattedMessage id={buttonText} />
            </Button>
          )}
        </Flex>
      </Flex>
      {isRecommended && <Recommended />}
    </StyledCard>
  )
}

export default injectIntl(ModalWidget)
